/* Common.js
 * In order to add imports to common.js they must be added to:
 * lib/index.js
 * lib/navbar.js
 * lib/header.js
*/

// to support IE9+
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.keys';

import 'zepto';
import './components/legacy/tooltips';
import './components/stickyBanner';

// navbar.js
import './utils/legacy/index';
import './components/legacy/countryPicker';
import './components/fields';
import { expose } from './main';
import { initNavigation } from './components/navigation';

expose({ initNavigation });
